import i18n from '@/lang'

const formatPrice = (priceString) => {
  if (!priceString) return ''
  const price = parseFloat(priceString)

  // 检测输入字符串的小数位数
  const decimalPlaces = (() => {
    const str = String(priceString)
    const dotIndex = str.indexOf('.')
    if (dotIndex === -1) return 0
    return str.length - dotIndex - 1
  })()

  const options = {
    useGrouping: true,
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }

  if (i18n.locale === 'AR') {
    return price.toLocaleString('EN', options).replace(/\s/g, ' ')
  }
  return price.toLocaleString(i18n.locale, options).replace(/\s/g, ' ')
}

// 根据时间返回 天 时 分 秒
// 如果时间小于 1 天，则返回 时 分 秒
// 入参单位：秒，返回格式：两位数的时分秒
const formatTime = (time) => {
  time = isNaN(time) ? 0 : Math.abs(time)
  const days = Math.floor(time / (60 * 60 * 24))
  const hours = Math.floor((time % (60 * 60 * 24)) / (60 * 60))
  const minutes = Math.floor((time % (60 * 60)) / 60)
  const seconds = Math.floor(time % 60)

  // 兼容性更好的格式化为两位数方法
  const formatNumber = (num) => {
    const str = num.toString()
    return str.length < 2 ? '0' + str : str
  }

  if (days > 0) {
    return `${days}D ${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(seconds)}`
  } else {
    return `${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(seconds)}`
  }
}

const termsUrl = (locale) => {
  const localeMap = {
    EN: '',
    // 'zh-Hans': 'zh/',
    // 'zh-Hant': 'zh/',
    KO: 'ko/',
    JA: 'ja/',
  }
  return `https://www.centurygames.com/${localeMap[locale] || ''}terms-of-service/`
}

const filters = {
  formatPrice,
  formatTime,
  termsUrl,
}

export default {
  install(Vue) {
    Object.keys(filters).forEach((key) => {
      Vue.filter(key, filters[key])
    })
  },
}
